import Vue from 'vue'
import VueRouter from 'vue-router'
import HrBot from "@/layouts/HrBot.vue";
import AccessToCoursesChannelBot from "@/layouts/AccessToCoursesChannelBot.vue";
import SendLinkToCoursesBot from "@/layouts/SendLinkToCoursesBot.vue";
import AffologizeBot from "@/layouts/AffologizeBot.vue";
import UaffHrBot from "@/layouts/UaffHrBot.vue";

const base = '/affy/'

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: 'root',
    },
    {
        path: '/hr-bot',
        name: 'hr-bot',
        props: {botName: 'hr-bot'},
        component: HrBot,
    },
    {
        path: '/access-to-courses-channel-bot',
        name: 'access-to-courses-channel-bot',
        props: {botName: 'access-to-courses-channel-bot'},
        component: AccessToCoursesChannelBot,
    },
    {
        path: '/send-course-link-bot',
        name: 'send-course-link-bot',
        props: {botName: 'send-course-link-bot'},
        component: SendLinkToCoursesBot,
    }, {
        path: '/affologize-bot',
        name: 'affologize-bot',
        props: {botName: 'affologize-bot'},
        component: AffologizeBot,
    },
    {
        path: '/uaff-hr-bot',
        name: 'uaff-hr-bot',
        props: {botName: 'uaff-hr-bot'},
        component: UaffHrBot,
    },
    {
        path: "*",
        name: 'anotherRoute',
        redirect: { name: "hr-bot" },
    }
]

const router = new VueRouter({
    mode: 'history',
    base,
    routes,
})

export default router
